module.exports = __webpack_public_path__ + "fonts/669d8ad.otf";